import React, { useState } from "react"
import { AlertBanner as Alert } from "trimble-terra"
import { getTextOption } from "../formatBaseMolecules"
import "./SiteWideAlert.scss"
import GridWrapper from "../../../components/GridWrapper/GridWrapper"
import { useEffect } from "react"
import { withinDateRange } from "../../../components/OverlayNotice/OverlayNoticeMethods"

const FormatAndRenderSiteWideAlert = ({ data }) => {
  return data?.map((alert, i) => {
    const alertText = getTextOption(alert?.details)
    const alertContent = {
      alertID: alert?.alertID,
      id: alert?.contentfulId,
      type: alert?.type,
      title: alert?.title,
      text: alertText,
      startDate: alert?.startDate,
      endDate: alert?.endDate,
      redisplayDays: alert?.redisplayDays,
    }
    return (
      <SiteWideAlert
        key={alert?.alertID || alert?.contentfulId}
        data={alertContent}
      />
    )
  })
}

const setLocalStorageAlert = (currentDate, alertID, redisplayDays) => {
  if (typeof window === "undefined") {
    return
  }
  localStorage?.setItem(
    `site-wide-alert-${alertID}`,
    JSON.stringify({ date: currentDate, redisplay: redisplayDays })
  )
}

const checkDisplayAlert = (currentDate, alertID, redisplayDays) => {
  if (typeof window === "undefined") {
    return
  }
  const msDay = 60 * 60 * 24 * 1000 // milliseconds in one day
  const parsedLsEntry = JSON.parse(
    localStorage?.getItem(`site-wide-alert-${alertID}`)
  )
  const alertDismissedDate = parsedLsEntry?.date
  const differenceDays = Math.floor((currentDate - alertDismissedDate) / msDay)

  if (parsedLsEntry === null) {
    // if there is no localStorage entry, then show the alert as it hasn't been dismissed
    return true
  } else if (parsedLsEntry?.redisplay !== redisplayDays) {
    // if alert gets dismissed initially, then the redisplay property gets changed in contentful
    const updatedEntry = {
      date: alertDismissedDate,
      redisplay: redisplayDays ? redisplayDays : false,
    }
    localStorage.removeItem(`site-wide-alert-${alertID}`)
    localStorage.setItem(
      `site-wide-alert-${alertID}`,
      JSON.stringify(updatedEntry)
    )
    return false
  } else if (
    parsedLsEntry?.redisplay === false ||
    parsedLsEntry?.redisplay === 0
  ) {
    // if redisplay is not set in contentful, then don't show the alert again after it's dismissed
    return false
  } else if (differenceDays >= parsedLsEntry?.redisplay) {
    // show the alert, it's been longer than 'redisplay' since it was dismissed
    localStorage?.removeItem(`site-wide-alert-${alertID}`)
    return true
  } else if (differenceDays < parsedLsEntry?.redisplay) {
    // it hasn't been long enough yet, don't re-display the alert
    return false
  }
}

const SiteWideAlert = ({ data }) => {
  const [displayAlert, setDisplayAlert] = useState(false)
  const currentDate = new Date().getTime()
  const alertInDateRange = withinDateRange(data?.startDate, data?.endDate)

  useEffect(() => {
    setDisplayAlert(
      checkDisplayAlert(currentDate, data?.id, data?.redisplayDays)
    )
  }, [currentDate])

  const handleCloseAlert = currentDate => {
    // set a cookie when user dismisses the alert
    setLocalStorageAlert(
      currentDate,
      data?.id,
      data?.redisplayDays != null ? data?.redisplayDays : false
    )
    setDisplayAlert(false)
  }

  return (
    alertInDateRange &&
    displayAlert && (
      <GridWrapper
        children={
          <div className={`mxp-alert`}>
            <Alert
              type={data?.type}
              title={data?.title}
              text={data?.text}
              handleClose={() => handleCloseAlert(currentDate)}
            />
          </div>
        }
      />
    )
  )
}

export default FormatAndRenderSiteWideAlert
